module.exports = __webpack_public_path__ + "static/bannerrevised4-9b3bd03a5ad16023783a5d27fa8348d2.png";